module.exports = __webpack_public_path__ + "static/laptop-ed457e6cf0d22972c4ed5ce57ab9254f.png";